import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWardrobe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWardrobe"><Path fillRule="evenodd" clipRule="evenodd" d="M11.25 2H4V20H6V22H7.5V20H11.25V2ZM9.5 9H8V13H9.5V9Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M18 20H20V2H12.75V20H16.5V22H18V20ZM16 9V13H14.5V9H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWardrobe;
